module.exports = {
    clgl: {
        formTitle: '车辆管理',
        moduleMenu: {
            vehicleHome: '车辆主页',
            MyApproval: '我的审批',
            todo: '待处理',
            done: '已处理',
            MyCar: '我的用车',
            MyDispatchTicket: '我的派车单',
            MyApplicaForm: '我的申请单',
            all: '全部',
            draft: '草稿',
            progress: '处理中',
            Ended: '已结束',
            VehicleGl: '派车管理',
            PendingVehicle: '待派车',
            SentCar: '已派车',
            VehicleManagement: '车辆管理',
            carInfo: '车辆信息',
            carInsurance: '车辆保险',
            carAnnualReview: '车辆年审',
            carRepair: '车辆维修',
            DriverMan: '司机管理',
            FuelCardMan: '加油卡管理',
            FuelCardInfo: '加油卡信息',
            FuelCardRecharge: '加油卡充值',
            FuelCardCon: '加油卡消费',
            carRemind: '车辆提醒',
            InsuranceExpires: '保险到期',
            AnnualReviewExpires: '年审到期',
            StatisticalReport: '统计报表',
            UnitVehicle: '单位用车统计',
            RepairCosts: '维修费用统计',
            DriverDriving: '司机出车统计',
            FuelCardRechargetj: '加油卡充值统计',
            FuelCardContj: '加油卡消费统计'
        },
        clxx: {
            index: '序号',
            carNumber: '车牌号',
            carType: '车辆类型',
            carModel: '品牌型号',
            drivingLicense: '行驶证',
            totalPassenger: '载客数',
            carRegistTime: '年审有效期至',
            clInfo: '车辆信息'
        },
        pcgl: {
            DispatchCar: '派车',
            refuse: '拒绝',
            cancel: '取消',
            delay: '延期',
            ReturnCar: '还车',
            update: '修改',
            look: '查看',
            Directgl: '派车管理',
            DirectVehicles: '直接派车',
            delayCar: '延期还车',
            zjhCar: '直接还车',
            cancelCar: '确定要取消派车吗？',
            refuseCar: '确定要拒绝派车吗？',
            refuseCarEd: '已拒绝派车！',
            tip: '提示'
        },
        portlet: {
            Seat: '座',
            UsingCar: '用车',
            to: '至',
            AlreadyBooked: '已预约',
            PendingVehicle: '待派车',
            SentCar: '已派车',
            OutCar: '出车中',
            ReturnedCar: '已还车',
            Rejected: '已拒绝',
            Cancelled: '已取消',
            AccompanyDriver: '随车司机',
            SelfDriving: '自驾',
            notData: '暂无数据',
            ArrivalLocation: '抵达地点',
            Apply: '申请于',
            status: '状态'

        },
        tjbb: {
            StatisticalCycle: '统计周期',
            to: '至',
            startTime: '开始日期',
            endTime: '结束日期',
            Statistics: '统计',
            UnitVehicle: '单位用车统计',
            dept: '部门',
            num: '次数',
            flCreateDept: '用车部门',
            totalPerson: '乘车人数',
            carUseNum: '车辆使用次数',
            yearYk: '{curYear1}年加油卡充值统计',
            JykTable: {
                index: '序号',
                cardNumber: '加油卡号',
                carNumber: '车牌号',
                one: '1月',
                two: '2月',
                three: '3月',
                four: '4月',
                fine: '5月',
                six: '6月',
                seven: '7月',
                eight: '8月',
                nine: '9月',
                ten: '10月',
                eleven: '11月',
                twelve: '12月',
                total: '合计(元)',
                Rechargev: '{curYear2}年充值费用（元）',
                RechargeFee: '加油卡充值费用',
                AnnualFuelCard: '{curYear1}年加油卡消费统计'
            },
            DriverTrip: '司机出车统计',
            DriverName: '司机名称',
            frequency: '次数',
            DriverUsage: '{date1}至{date2}司机用车统计',
            sjyc: {
                driverName: '姓名',
                driverPhone: '电话',
                driverNumber: '驾驶证号',
                drivingAge: '司机驾龄',
                driverType: '驾驶证类别',
                driverNum: '出车次数',

                contentEnter: '请输入内容',
                search: '查询'
            },
            AnnualMain: '{curYear1}年维修费用统计',
            DisDetai: '派车详情',
            isDelete: '确定要删除该条数据吗？'
        }
    }

}
